import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useNavigate } from "react-router-dom";
import { Table as TB } from "antd";
import callApi from "../../helpers/callApi";
import ExportComponents from "../../Components/ExportComponents";
import TitleHeader from "../accounts/Components/TitleHeader";
import { AuthContext } from "../../Auth/Context/AuthContext";
function ContractList(props) {
  const { user } = useContext(AuthContext);
  const columns = [
    {
      dataIndex: "name",
      title: "Shop Name",
    },
    {
      dataIndex: "shopkeeper",
      title: "Shopkeeper",
    },
    {
      dataIndex: "shop",
      title: "Shop",
    },
    {
      dataIndex: "contractType",
      responsive: ["sm"],
      title: "Contract Type",
    },
    {
      dataIndex: "startDate",
      title: "Start Date",
    },
    {
      dataIndex: "endDate",
      responsive: ["sm"],
      title: "EndDate",
    },
    {
      dataIndex: "status",
      responsive: ["sm"],
      title: "Status",
      // filters: [
      //   {
      //     text: "Active",
      //     value: "Yes",
      //   },
      //   {
      //     text: "Inactive",
      //     value: "No",
      //   },
      // ],
      // filterMode: "tree",
      // filterSearch: true,
      // onFilter: (value, record) => record.status.startsWith(value),
    },
    // {
    //   dataIndex: "action",
    //   responsive: ["sm"],
    //   title: "Action",
    // },
  ];

  const navigate = useNavigate();
  const [shopList, setShopList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [filters, setFilters] = useState();
  let pageSizeValue = 15;
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: pageSizeValue,
      showSizeChanger: true,
      pageSizeOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
    },
  });

  let paging = { current: 1 };
  const handleTableChange = async (pagination, filter, sorter) => {
    pageSizeValue = pagination.pageSize;
    setTableParams({ pagination, filter, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setShopList([]);
    }
    const params = { size: pagination.pageSize };
    paging.current = pagination.current;
    if (filters) {
      let fils = filters;
      fils.page = pagination.current;
      fils.pageSize = pageSizeValue;
      await fetchData(fils);
    } else {
      await fetchData(params);
    }
  };

  async function fetchData(params = {}) {
    setLoading(true);
    let endpoint = `shop-contracts/branch-shops-contracts?branchId=${user.branchId}`;
    const params1 = {
      ...params,
      page: !isFilter ? paging.current : params.page || 1,
      size: pageSizeValue || null,
    };
    await callApi(endpoint, null, null)
      .then((response) => {
        setLoading(false);
        if (response.data && response.status === 200) {
          setShopList(response.data);
          const totalStudents = response.headers.get("x-total-count");
          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: totalStudents,
              current: params1.page,
              pageSize: pageSizeValue,
            },
          });
        } else {
          console.log("students error");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("__ error", error);
        setLoading(false);
      });
  }

  // const onFilter = async (values) => {
  //   setIsFilter(true);
  //   setTableParams({
  //     ...tableParams,
  //     pagination: {
  //       ...tableParams.pagination,
  //       current: 1,
  //     },
  //   });
  //   let params = {
  //     page: 1,
  //   };
  //   paging.current = 1;
  //   params.institute_enrollment__institute = values.filterInstitute?.value;
  //   params.main_province = values.main_province?.value;

  //   setFilters(params);
  //   localStorage.setItem("shopParams", JSON.stringify(params));
  //   fetchData(params);
  // };

  const editShop = (id) => {
    navigate(`/edit-shop/${id}`);
  };

  const deleteShop = async (id) => {
    alert("Item will be deleted");
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <TitleHeader
            title={`Contracts List-(${tableParams.pagination?.total})`}
          />
          <div class="page-btn">
            <a href="/add-contract" class="btn btn-added">
              <img src="/assets/img/icons/plus.svg" alt="img" class="me-1" />
              Make New Contract
            </a>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="table-top">
                <div class="search-set">
                  <div class="search-path">
                    <a class="btn btn-filter" id="filter_search">
                      <img src="/assets/img/icons/filter.svg" alt="img" />
                      <span>
                        <img src="/assets/img/icons/closes.svg" alt="img" />
                      </span>
                    </a>
                  </div>
                  <div class="search-input">
                    <a class="btn btn-searchset">
                      <img src="/assets/img/icons/search-white.svg" alt="img" />
                    </a>
                  </div>
                </div>
                <ExportComponents
                  excelData={shopList}
                  fileName={"Contracts.xlsx"}
                />
              </div>

              <div class="card mb-0" id="filter_inputs">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12">
                      <div class="row">
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Shop</option>
                              <option>Macbook pro</option>
                              <option>Orange</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Category</option>
                              <option>Computers</option>
                              <option>Fruits</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Sub Category</option>
                              <option>Computer</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Brand</option>
                              <option>N/D</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12 ">
                          <div class="form-group">
                            <select class="select">
                              <option>Price</option>
                              <option>150.00</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg-1 col-sm-6 col-12">
                          <div class="form-group">
                            <a class="btn btn-filters ms-auto">
                              <img
                                src="/assets/img/icons/search-whites.svg"
                                alt="img"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <TB
                size="large"
                columns={columns}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
                loading={loading}
                dataSource={shopList?.map((item, index) => ({
                  key: item._id,
                  name: <p>{item.name}</p>,

                  shopkeeper: item.shopkeeperName,
                  shop: item.shopName,
                  contractType: item.contractType,
                  startDate: item.startDate,
                  endDate: item.endDate || (
                    <p style={{ color: "green" }}>Active</p>
                  ),
                  status: (
                    <p
                      style={{
                        color: item.state == "ACTIVE" ? "greene" : "red",
                      }}
                    >
                      {item.state}
                    </p>
                  ),
                  action: (
                    <div>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() => navigate(`/shop-details/${item.id}`)}
                      >
                        <img src="/assets/img/icons/eye.svg" alt="img" />
                      </button>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() => editShop(item.id)}
                      >
                        <img src="assets/img/icons/edit.svg"></img>
                      </button>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() => deleteShop(item.id)}
                      >
                        <img src="assets/img/icons/delete.svg"></img>
                      </button>
                    </div>
                  ),
                }))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContractList;
